export default [
  [
    {
      title: ["ROCKWOOL", "BRANDSCHUTZSCHALE CONLIT®"],
      link: "https://www.rockwool.com/de/produkte/brandabschottung-conlit-brandschutz/rohrabschottung/",
      pdf: [
        {
          name: "ROCKWOOL Conlit® P-3726/4140 MPA BS",
          link: "./pdf/ROCKWOOL_Conlit_P3726_4140_MPA_BS.pdf",
        },
        {
          name: "ROCKWOOL Conlit® GA-2014/291a",
          link: "./pdf/ROCKWOOL_Conlit_GA_2014_291a.pdf",
        },
      ],
    },
    {
      title: ["FLAM"],
      link: "https://www.conel.de/produkte/flam",
      pdf: [
        {
          name: "FLAM Manschette Z-19.53-2462",
          link: "./pdf/FLAM_Manschette_Z-19.53-2462.pdf",
        },
      ],
    },
    {
      title: ["CONNECT MV"],
      link: "https://www.conel.de/produkte/connect/mv-rohre-fittings-rohrinstallationssystem",
      pdf: [
        {
          name: "TI Connect-MV",
          link: "./pdf/TI_Connect-MV.pdf",
        },
      ],
    },
    {
      title: ["DRAIN"],
      link: "https://www.conel.de/produkte/drain/abwassersystem",
      pdf: [
        {
          name: "DRAIN Schallschutz-Zertifikat",
          link: "./pdf/DRAIN_Schallschutzzertifikat.pdf",
        },
        {
          name: "DRAIN Brandlast MPA",
          link: "./pdf/DRAIN_Brandlast.pdf",
        },
        {
          name: "TI DRAIN Abflussrohrsystem",
          link: "./pdf/TI_DRAIN_Abflussrohrsystem.pdf",
        },
      ],
    },
    {
      title: ["STREAM"],
      link: "https://www.conel.de/produkte/stream",
      pdf: [],
    },
    {
      title: ["FLEX WOOL"],
      link: "https://www.conel.de/produkte/flex/isolierschale-50-flex-wool",
      pdf: [],
    },
    {
      title: ["CLIC"],
      link: "https://www.conel.de/produkte/clic",
      pdf: [],
    },
    {
      title: ["VIS"],
      link: "https://www.conel.de/produkte/vis",
      pdf: [],
    },
  ],
  [
    {
      title: ["ROCKWOOL", "Brandschutzschale Conlit®"],
      link: "https://www.rockwool.com/de/produkte/brandabschottung-conlit-brandschutz/rohrabschottung/",
      pdf: [
        {
          name: "ROCKWOOL Conlit® P-3726/4140 MPA BS",
          link: "./pdf/ROCKWOOL_Conlit_P3726_4140_MPA_BS.pdf",
        },
        {
          name: "ROCKWOOL Conlit® GA-2014/291a",
          link: "./pdf/ROCKWOOL_Conlit_GA_2014_291a.pdf",
        },
      ],
    },
    {
      title: ["FLAM"],
      link: "https://www.conel.de/produkte/flam",
      pdf: [
        {
          name: "FLAM Manschette Z-19.53-2462",
          link: "./pdf/FLAM_Manschette_Z-19.53-2462.pdf",
        },
      ],
    },
    {
      title: ["CONNECT MV"],
      link: "https://www.conel.de/produkte/connect/mv-rohre-fittings-rohrinstallationssystem",
      pdf: [
        {
          name: "TI Connect-MV",
          link: "./pdf/TI_Connect-MV.pdf",
        },
      ],
    },

    {
      title: ["STREAM"],
      link: "https://www.conel.de/produkte/stream",
      pdf: [],
    },
    {
      title: ["DRAIN"],
      link: "https://www.conel.de/produkte/drain/abwassersystem",
      pdf: [
        {
          name: "DRAIN Schallschutz-Zertifikat",
          link: "./pdf/DRAIN_Schallschutzzertifikat.pdf",
        },
        {
          name: "DRAIN Brandlast MPA",
          link: "./pdf/DRAIN_Brandlast.pdf",
        },
        {
          name: "TI DRAIN Abflussrohrsystem",
          link: "./pdf/TI_DRAIN_Abflussrohrsystem.pdf",
        },
      ],
    },
    {
      title: ["FLEX WOOL"],
      link: "https://www.conel.de/produkte/flex/isolierschale-50-flex-wool",
      pdf: [],
    },
    {
      title: ["CLIC"],
      link: "https://www.conel.de/produkte/clic",
      pdf: [],
    },
    {
      title: ["VIS"],
      link: "https://www.conel.de/produkte/vis",
      pdf: [],
    },
  ],
  [
    {
      title: ["COSMO Deckenschot"],
      link: "https://www.cosmo-info.de/produkte/lueftungstechnik/wohnraumlueftung/wand-und-deckenschott",
      pdf: [
        {
          name: "COSMO Deckenschott Z-41.3-690",
          link: "./pdf/COSMO_Deckenschott_Z_41_3_690.pdf",
        },
        {
          name: "COSMO Deckenschott GU",
          link: "./pdf/COSMO_Deckenschott_GU.pdf",
        },
      ],
    },
    {
      title: ["ROCKWOOL", "Brandschutzschale Conlit®"],
      link: "https://www.rockwool.com/de/produkte/brandabschottung-conlit-brandschutz/rohrabschottung/",
      pdf: [
        {
          name: "ROCKWOOL Conlit® P-3726/4140 MPA BS",
          link: "./pdf/ROCKWOOL_Conlit_P3726_4140_MPA_BS.pdf",
        },
        {
          name: "ROCKWOOL Conlit® GA-2014/291a",
          link: "./pdf/ROCKWOOL_Conlit_GA_2014_291a.pdf",
        },
      ],
    },
    {
      title: ["FLAM"],
      link: "https://www.conel.de/produkte/flam",
      pdf: [
        {
          name: "FLAM Manschette Z-19.53-2462",
          link: "./pdf/FLAM_Manschette_Z-19.53-2462.pdf",
        },
      ],
    },
    {
      title: ["COSMO Wohnungslüftung"],
      link: "https://www.cosmo-info.de/produkte/lueftungstechnik/wohnraumlueftung",
      pdf: [
        {
          name: "COSMO EL Z-51.1-370",
          link: "./pdf/COSMO_EL_Z-51.1-370.pdf",
        },
      ],
    },
    {
      title: ["CONNECT MV"],
      link: "https://www.conel.de/produkte/connect/mv-rohre-fittings-rohrinstallationssystem",
      pdf: [
        {
          name: "TI Connect-MV",
          link: "./pdf/TI_Connect-MV.pdf",
        },
      ],
    },
    {
      title: ["STREAM"],
      link: "https://www.conel.de/produkte/stream",
      pdf: [],
    },
    {
      title: ["DRAIN"],
      link: "https://www.conel.de/produkte/drain/abwassersystem",
      pdf: [
        {
          name: "DRAIN Schallschutz-Zertifikat",
          link: "./pdf/DRAIN_Schallschutzzertifikat.pdf",
        },
        {
          name: "DRAIN Brandlast MPA",
          link: "./pdf/DRAIN_Brandlast.pdf",
        },
        {
          name: "TI DRAIN Abflussrohrsystem",
          link: "./pdf/TI_DRAIN_Abflussrohrsystem.pdf",
        },
      ],
    },
    {
      title: ["FLEX WOOL"],
      link: "https://www.conel.de/produkte/flex/isolierschale-50-flex-wool",
      pdf: [],
    },
    {
      title: ["CLIC"],
      link: "https://www.conel.de/produkte/clic",
      pdf: [],
    },
    {
      title: ["VIS"],
      link: "https://www.conel.de/produkte/vis",
      pdf: [],
    },
  ],
  [
    {
      title: ["VIS"],
      link: "https://www.conel.de/produkte/vis",
      pdf: [
        {
          name: "VIS Schallschutz-Zertifikat RH",
          link: "./pdf/VIS_Schallschutzzertifikat_RH.pdf",
        },
        {
          name: "VIS Schallschutz-Zertifikat MW",
          link: "./pdf/VIS_Schallschutzzertifikat_MW.pdf",
        },
      ],
    },
    {
      title: ["FLEX"],
      link: "https://www.conel.de/produkte/flex",
      pdf: [],
    },
    {
      title: ["CONNECT MV"],
      link: "https://www.conel.de/produkte/connect/mv-rohre-fittings-rohrinstallationssystem",
      pdf: [
        {
          name: "TI Connect-MV",
          link: "./pdf/TI_Connect-MV.pdf",
        },
      ],
    },
    {
      title: ["DRAIN"],
      link: "https://www.conel.de/produkte/drain/abwassersystem",
      pdf: [
        {
          name: "DRAIN Schallschutz-Zertifikat",
          link: "./pdf/DRAIN_Schallschutzzertifikat.pdf",
        },
        {
          name: "TI DRAIN Abflussrohrsystem",
          link: "./pdf/TI_DRAIN_Abflussrohrsystem.pdf",
        },
      ],
    },
  ],
];
